import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f1591b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-week-box" }
const _hoisted_2 = { class: "calendar-week" }
const _hoisted_3 = { class: "calendar-head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calendar-daily-intervals" }, null, -1))
const _hoisted_5 = { class: "head-day" }
const _hoisted_6 = { class: "calendar-body" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"calendar-intervals-body\" data-v-5f1591b3><div class=\"calendar-intervals\" data-v-5f1591b3><div class=\"calendar-intervals-text-first\" data-v-5f1591b3>00:00</div><div class=\"calendar-intervals-text\" data-v-5f1591b3>04:00</div></div><div class=\"calendar-intervals\" data-v-5f1591b3><div class=\"calendar-intervals-text\" data-v-5f1591b3>08:00</div></div><div class=\"calendar-intervals\" data-v-5f1591b3><div class=\"calendar-intervals-text\" data-v-5f1591b3>12:00</div></div><div class=\"calendar-intervals\" data-v-5f1591b3><div class=\"calendar-intervals-text\" data-v-5f1591b3>16:00</div></div><div class=\"calendar-intervals\" data-v-5f1591b3><div class=\"calendar-intervals-text\" data-v-5f1591b3>20:00</div></div><div class=\"calendar-intervals\" data-v-5f1591b3><div class=\"calendar-intervals-text\" data-v-5f1591b3>24:00</div></div></div>", 1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"calendar-day-intervals\" data-v-5f1591b3></div><div class=\"calendar-day-intervals\" data-v-5f1591b3></div><div class=\"calendar-day-intervals\" data-v-5f1591b3></div><div class=\"calendar-day-intervals\" data-v-5f1591b3></div><div class=\"calendar-day-intervals\" data-v-5f1591b3></div><div class=\"calendar-day-intervals calendar-day-intervals-last\" data-v-5f1591b3></div>", 6)
const _hoisted_14 = {
  key: 0,
  class: "timed-container"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "timed-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allDataWeek, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "head-day",
            key: index
          }, [
            _createElementVNode("div", null, _toDisplayString(_ctx.changeDateGetMonthDay(item.title)), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.weekTitle[_ctx.dayjs(item.title).day()]), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allDataWeek, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "calendar-day",
            key: index
          }, [
            _hoisted_8,
            (item.children.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (timeItem, timeIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "timed",
                      key: timeIndex + timeItem.mode,
                      style: _normalizeStyle({
                top: timeItem.top + 'px',
                height: timeItem.height + 'px',
                width: timeItem.width + 'px',
                background: timeItem.color,
                left: timeItem.left + 'px'
              })
                    }, [
                      _createVNode(_component_a_popover, {
                        title: timeItem.title,
                        trigger: "click"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.rqp3ld')) + "：" + _toDisplayString(timeItem.customerName || '--'), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.agy27l')) + "：" + _toDisplayString(timeItem.contactName || '--'), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.rzzoit')) + "：" + _toDisplayString(timeItem.startTime || '--'), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.ld71ju')) + "：" + _toDisplayString(timeItem.mode || '--'), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t('home.5afs7f')) + "：" + _toDisplayString(timeItem.purpose || '--'), 1)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 2
                      }, 1032, ["title"])
                    ], 4))
                  }), 128)),
                  (_ctx.nowWeek.findIndex((weekitem)=>weekitem===item.title)===-1?false:true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["current-time", item.title == _ctx.dayjs().format('YYYY/MM/DD') ? 'current-time-first' : '']),
                        style: _normalizeStyle({ top: _ctx.nowDate + 'px' })
                      }, null, 6))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_ctx.nowWeek.findIndex((weekitem)=>weekitem===item.title)===-1?false:true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["current-time", item.title == _ctx.dayjs().format('YYYY/MM/DD') ? 'current-time-first' : '']),
                        style: _normalizeStyle({ top: _ctx.nowDate + 'px' })
                      }, null, 6))
                    : _createCommentVNode("", true)
                ]))
          ]))
        }), 128))
      ])
    ])
  ]))
}